// ======================================================================
// File Name       : ModalConductorConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from '../../constants/ModalIds';

import EnterpriseRegisterEditContainer from '../../containers/enterprise/EnterpriseRegisterEditContainer';
import EnterpriseDetailConfirmContainer from '../../containers/enterprise/EnterpriseDetailConfirmContainer';
import EnterpriseNoticeConfirmContainer from '../../containers/enterprise/EnterpriseNoticeConfirmContainer';
import EnterprisePreCancelContainer from '../../containers/enterprise/EnterprisePreCancelContainer';
import EnterprisePreCancelConfirmContainer from '../../containers/enterprise/EnterprisePreCancelConfirmContainer';

import CourseRegisterEditContainer from '../../containers/course/CourseRegisterEditContainer';
import CourseSortContainer from '../../containers/course/CourseSortContainer';
import CourseDetailContainer from '../../containers/course/CourseDetailContainer';
import CourseEditUserContainer from '../../containers/course/CourseEditUserContainer';
import CourseEditGroupContainer from '../../containers/course/CourseEditGroupContainer';

import ItemTreeContainer from '../../containers/item/ItemTreeContainer';

import BoxDetailContainer from '../../containers/box/BoxDetailContainer';
import BoxRegisterEditContainer from '../../containers/box/BoxRegisterEditContainer';

import ContentLinkingDetailContainer from '../../containers/course/ContentLinkingDetailContainer';
import ContentLinkingRegisterContainer from '../../containers/course/ContentLinkingRegisterContainer';
import ContentLinkingDetailSettingRegisterEditContainer from '../../containers/course/ContentLinkingDetailSettingRegisterEditContainer';

import GroupDetailConfirmContainer from '../../containers/group/GroupDetailConfirmContainer';
import GroupRegisterEditContainer from '../../containers/group/GroupRegisterEditContainer';
import GroupUserAdminContainer from '../../containers/group/GroupUserAdminContainer';
import GroupUserNotAdminContainer from '../../containers/group/GroupUserNotAdminContainer';
import ReportModalDialogContainer from '../../containers/report/scoring/ScoringReportModalDialogContainer';
import SelectGroupDialogContainer from '../../containers/group/SelectGroupDialogContainer';
import SelectGroupUserHistoryDlgContainer from '../../containers/group/SelectGroupUserHistoryDialogContainer';
import DistributionReportAssignmentContainer from '../../containers/report/distribution/DistributionReportAssignmentContainer';
import RegisterUserDialogContainer from '../../containers/messageThread/RegisterUserDialogContainer';
import RegisterMessageConfirmContainer from '../../containers/messageThread/RegisterMessageConfirmContainer';
import SelectGroupModalContainer from '../../containers/service/SelectGroupModalContainer';
import ServiceNoticeRegisterUserContainer from '../../containers/service/ServiceNoticeRegisterUserContainer';
import ServiceNoticeConfirmDialog from '../../containers/service/ServiceNoticeConfirmDialog';
import NoticeEnterpriseDetailDialog from '../../containers/top/NoticeEnterpriseDetailDialog';
import NoticeServiceDetailDialog from '../../containers/top/NoticeServiceDetailDialog';
import SelectGroupModal from '../../containers/SelectGroupModal';

import SelectUsersContainer from '../../containers/user/SelectUsersContainer';
import LiveRegisterConfirmContainer from '../../containers/usageSettingLive/LiveRegisterConfirmContainer';
import SelectServiceUserDialog from '../../components/userHistory/csv/SelectServiceUserDialog';
import SelectCourseDialog from '../../components/userHistory/csv/SelectCourseDialog';
import SelectContentLinkCourseDialog from '../../components/userHistory/csv/SelectContentLinkCourseDialog';

import EmailDetailDialog from '../email/EmailDetailDialog';
import EmailRegisterEditUserContainer from '../../containers/email/EmailRegisterEditUserContainer';
import ReservedEmailConfirmDialog from '../email/ReservedEmailConfirmDialog';

import TranslateConfirmContainer from '../multiLanguage/TranslateConfirmContainer';
import TranslateCompleteContainer from '../multiLanguage/TranslateCompleteContainer';
import TranslateConfirmDialog from '../multiLanguage/TranslateConfirmDialog';
import EnterpriseReasonForCancelContainer from '../../containers/enterprise/EnterpriseReasonForCancelContainer';
import ServiceGroupRegisterEditContainer from '../../containers/serviceGroup/ServiceGroupRegisterEditContainer';
import ServiceGroupServiceContainer from '../../containers/serviceGroup/ServiceGroupServiceContainer';
import ServiceGroupSuperUserContainer from '../../containers/serviceGroup/ServiceGroupSuperUserContainer';
import ServiceGroupDetailContainer from '../../containers/serviceGroup/ServiceGroupDetailContainer';
import ServiceGroupConfirmContainer from '../serviceGroup/ServiceGroupConfirmContainer';
import SelectBoxDialog from '../userHistory/csv/SelectBoxDialog';

export const ModalCondutor = {
  [ModalIds.ENTERPRISE_DETAIL]: EnterpriseDetailConfirmContainer,
  [ModalIds.ENTERPRISE_EDIT]: EnterpriseRegisterEditContainer,
  [ModalIds.ENTERPRISE_REGISTER]: EnterpriseRegisterEditContainer,
  [ModalIds.ENTERPRISE_CONFIRM]: EnterpriseDetailConfirmContainer,
  [ModalIds.ENTERPRISE_PRECANCEL]: EnterprisePreCancelContainer,
  [ModalIds.ENTERPRISE_PRECANCEL_CONFIRM]: EnterprisePreCancelConfirmContainer,
  [ModalIds.ENTERPRISE_REASON_FOR_CANCEL]: EnterpriseReasonForCancelContainer,

  [ModalIds.COURSE_REGISTER_EDIT]: CourseRegisterEditContainer,
  [ModalIds.COURSE_SORT]: CourseSortContainer,
  [ModalIds.COURSE_DETAIL]: CourseDetailContainer,
  [ModalIds.COURSE_CONFIRM]: CourseDetailContainer,
  [ModalIds.COURSE_EDIT_USER]: CourseEditUserContainer,
  [ModalIds.COURSE_EDIT_GROUP]: CourseEditGroupContainer,

  [ModalIds.ITEM_TREE_CONTAINER]: ItemTreeContainer,
  [ModalIds.CONTENT_LINKING_CONFIRM]: ContentLinkingDetailContainer,
  [ModalIds.CONTENT_LINKING_DETAIL]: ContentLinkingDetailContainer,
  [ModalIds.CONTENT_LINKING_REGISTER]: ContentLinkingRegisterContainer,
  [ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING]: ContentLinkingDetailSettingRegisterEditContainer,

  [ModalIds.BOX_DETAIL]: BoxDetailContainer,
  [ModalIds.BOX_CONFIRM]: BoxDetailContainer,
  [ModalIds.BOX_REGISTER_EDIT]: BoxRegisterEditContainer,

  [ModalIds.GROUP_DETAIL]: GroupDetailConfirmContainer,
  [ModalIds.GROUP_CONFIRM]: GroupDetailConfirmContainer,
  [ModalIds.GROUP_REGISTER_EDIT]: GroupRegisterEditContainer,
  [ModalIds.GROUP_USER_ADMIN]: GroupUserAdminContainer,
  [ModalIds.GROUP_USER_NOT_ADMIN]: GroupUserNotAdminContainer,
  [ModalIds.SELECT_GROUP_DIALOG]: SelectGroupDialogContainer,
  [ModalIds.SELECT_GROUP_USER_HISTORY_DIALOG]: SelectGroupUserHistoryDlgContainer,

  [ModalIds.ASSIGNMENT_DISTRIBUTION_REPORT]: DistributionReportAssignmentContainer,
  [ModalIds.REPORT_MODAL_DIALOG]: ReportModalDialogContainer,
  [ModalIds.ADD_USER_TO_MSG]: RegisterUserDialogContainer,
  [ModalIds.MSG_REGISTER_CONFIRM_DIALOG]: RegisterMessageConfirmContainer,
  [ModalIds.SELECT_GROUP_MODAL]: SelectGroupModalContainer,
  [ModalIds.SELECT_GROUP_MODAL_PARTICIPANT]: SelectGroupModal,
  [ModalIds.SERVICE_USER_DIALOG]: ServiceNoticeRegisterUserContainer,
  [ModalIds.SERVICE_NOTICE_CONFIRM_DIALOG]: ServiceNoticeConfirmDialog,
  [ModalIds.ENTERPRISE_NOTICE_CONFIRM]: EnterpriseNoticeConfirmContainer,
  [ModalIds.SERVICE_NOTICE_DETAIL]: NoticeServiceDetailDialog,
  [ModalIds.ENTERPRISE_NOTICE_DETAIL]: NoticeEnterpriseDetailDialog,
  [ModalIds.SELECT_USER_DIALOG]: SelectUsersContainer,
  [ModalIds.LIVE_REGISTER_CONFIRM]: LiveRegisterConfirmContainer,
  [ModalIds.SELECT_SERVICE_USER_DIALOG]: SelectServiceUserDialog,
  [ModalIds.SELECT_COURSE_DIALOG]: SelectCourseDialog,
  [ModalIds.SELECT_TARGET_CONTENT_DIALOG]: SelectContentLinkCourseDialog,
  [ModalIds.SELECT_TARGET_BOX_DIALOG]: SelectBoxDialog,

  [ModalIds.EMAIL_DETAIL_DIALOG]: EmailDetailDialog,
  [ModalIds.EMAIL_REGISTER_EDIT_USER]: EmailRegisterEditUserContainer,
  [ModalIds.RESERVED_EMAIL_CONFIRM_DIALOG]: ReservedEmailConfirmDialog,

  [ModalIds.TRANSLATE_CONFIRM]: TranslateConfirmContainer,
  [ModalIds.TRANSLATE_COMPLETE]: TranslateCompleteContainer,
  [ModalIds.TRANSLATE_CONFIRM_DIALOG]: TranslateConfirmDialog,

  [ModalIds.SERVICE_GROUP_REGISTER_EDIT]: ServiceGroupRegisterEditContainer,
  [ModalIds.SERVICE_GROUP_EDIT_SERVICE]: ServiceGroupServiceContainer,
  [ModalIds.SERVICE_GROUP_EDIT_SUPERUSER]: ServiceGroupSuperUserContainer,
  [ModalIds.SERVICE_GROUP_DETAIL]: ServiceGroupDetailContainer,
  [ModalIds.SERVICE_GROUP_CONFIRM]: ServiceGroupConfirmContainer,
};
